<template>
  <div>

    <!-- 场馆分类 -->
    <div>
      <van-tabs v-model="queryParams.status" title-active-color="#1989fa" :border="false" @change="tabChange">
        <van-tab title="全部" name=""/>
        <van-tab v-for="(item, index) in orderStatusOptions.filter(i => i.show)" :title="item.label" :name="item.value"
                 :key="index"/>
      </van-tabs>
    </div>

    <!-- 列表 -->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
          v-model="data.bottomLoading"
          :finished="!data.hasMore"
          finished-text="没有更多了"
          @load="bottomRefresh()"
      >
        <div class="yy-list" v-for="(item, index) in data.records" :key="index">
          <div class="yy-top" @click="toDetail(item)">
            <div class="yy-title">
              <span>{{ item.orderNo }}</span>
              <em :class="'status'+item.status">{{ getDictName(orderStatusOptions, item.status) }}</em>
            </div>
            <div class="yy-addres">
              <p><img src="@/assets/dw.png"> {{ item.groundName }}</p>
              <van-tag plain type="primary">
                {{ getDictName(sportTypeList, item.sportType) }}
              </van-tag>
            </div>
            <div class="yy-time">
              <span><img src="@/assets/time2.png">{{ item.createTime }}</span>
              <b :class="'pre-gary'+item.status">{{ item.totalAmount }}元</b>
            </div>
          </div>
          <div class="yy-bottom">
            <button class="edit" v-if="item.status === '0' && item.hasService === '1'" @click="openService(item)">修改服务
            </button>
            <button class="qx" v-if="item.status === '0' || item.status === '1'" @click="cancelReservation(item)">取消预约
            </button>
            <button class="pay" v-if="item.status === '0'" @click="$refs.campusCardPay.show(item)">立即支付</button>
            <button class="pay" v-if="item.status === '2'" @click="toEvaluate(item)">立即评价</button>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>

    <div>
      <!-- 待支付阶段 修改已选服务 -->
      <service-cart ref="serviceCart" @handleOk="handleOk"/>
      <!-- 立即支付的选择校园卡 -->
      <campus-card-payment ref="campusCardPay"/>
    </div>
  </div>
</template>

<script>
// import {getSettingByKey} from '@/api/venue/venue'
import {FILE_DISPLAY_PREFIX} from '@/api/upload'
import {queryList, cancel, updateService} from '@/api/order/order'
import {handlePageData} from '@/utils/common'
import {getDictByType} from '@/api/common'
import {getDictName} from '@/utils/common'
import CampusCardPayment from '@/views/order/components/CampusCardPayment'
import ServiceCart from '@/views/components/ServiceCart'
import {Dialog} from "vant";
import moment from 'moment'

export default {
  name: 'orderIndex',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    CampusCardPayment,
    // eslint-disable-next-line vue/no-unused-components
    ServiceCart
  },
  data() {
    return {
      moment,
      getDictName,
      fileDisplayPrefix: FILE_DISPLAY_PREFIX,
      queryParams: {},
      orderStatusOptions: [],
      sportTypeList: [],
      parameters: {},
      data: {
        records: [],
        current: 1,
        size: 10,
        total: 0,
        hasMore: true,
        loading: false,
        topLoading: false,
        bottomLoading: false
      },
      selectOrder: {}
    }
  },
  computed: {},
  created() {
    getDictByType('sport_type').then(res => {
      if (res.result) {
        this.sportTypeList = res.result.map(item => {
          return {label: item.dictKey, value: item.dictValue}
        })
      }
    })
    getDictByType('order_status').then(res => {
      if (res.code === 10000) {
        this.orderStatusOptions = res.result.map(item => {
          return { label: item.dictKey, value: item.dictValue }
        })
      }
    })
    this.refresh()
  },
  mounted() {
  },
  methods: {
    openService(item) {
      this.$refs.serviceCart.show(item.serviceList)
      this.selectOrder = item
    },
    handleOk(item) {
      if (item.length === 0) {
        this.$toast('请选择服务')
        return
      }
      const data = {
        id: this.selectOrder.id,
        serviceList: item
      }
      updateService(data).then(res => {
        if (res.code === 10000) {
          this.$toast('更新成功')
        }
      })
    },
    refresh() {
      this.reset()
      this.getList()
    },
    bottomRefresh() {
      if (this.data.current > 1 && this.data.hasMore)
        this.getList()
    },
    reset() {
      this.data.current = 1
      this.data.total = 0
      this.data.hasMore = true
    },
    getList() {
      if (this.data.loading) return
      this.data.loading = true
      this.queryParams.current = this.data.current
      this.queryParams.size = this.data.size
      queryList(this.queryParams).then(res => {
        if (res.code === 10000) {
          setTimeout(() => {
            handlePageData(this.data, res.result)
          }, 100)
        }
      }).finally(() => {
        setTimeout(() => {
          this.data.loading = false
          this.data.topLoading = false
          this.data.bottomLoading = false
        }, 100)
      })
    },
    tabChange() {
      this.$nextTick(() => {
        this.data.records = []
        this.refresh()
      })
    },

    back() {
      this.$router.go(-1)
    },

    cancelReservation(item) {
      let msg
      if (item.status === '1') {
        const cancelConfig = JSON.parse(item.cancelCharge)
        // 住宿和非住宿提示语
        if (item.isStay === '1') {
          msg = `是否取消（如果住宿当日${cancelConfig.cancel}之后取消，将扣除总价${cancelConfig.ratio}%的手续费）`
        } else {
          msg = `是否取消（如果场次开始时间少于${cancelConfig.cancel}小时，将扣除总价${cancelConfig.ratio}%的手续费）`
        }
      } else {
        msg = '是否取消'
      }
      Dialog.confirm({
        message: msg,
      })
          .then(() => {
            this.parameters.id = item.id
            cancel(this.parameters).then(res => {
              if (res.code === 10000) {
                this.$toast(res.result)
                this.refresh()
              } else {
                this.$toast(res.result)
              }
            })
          })
          .catch(() => {
          });

    },

    toDetail(item) {
      this.$router.push({path: `/order/detail?id=${item.id}`})
    },
    toEvaluate(item) {
      this.$router.push({path: `/order/evaluate?id=${item.id}`})
    }
  }
}
</script>

<style scoped>
>>> .van-tabs__line {
  background-color: #1989fa;
}

.yy-list {
  height: 164px;
  background: #FFFFFF;
  border-radius: 6px;
  margin: 10px 0;
  overflow: hidden;
}

.yy-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 42px;
  border-bottom: 1px solid #ededed;
  padding: 0 10px;
}

.yy-title span {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.yy-title em {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}

.yy-addres {
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
  margin: 15px 0;
}

.yy-addres p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  align-items: center;
}

.yy-addres p img {
  width: 12px;
  height: 14px;
  margin-right: 2px;
}

.yy-time {
  display: flex;
  align-items: center;
  padding: 0 10px;
  justify-content: space-between;
}

.yy-time span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: flex;
  align-items: center;
}

.yy-time span img {
  width: 12px;
  height: 12px;
  margin-right: 2px;
}

.yy-time b {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #FF6600;
}

/deep/ .van-tag--plain {
  margin-right: 0 !important;
  margin-left: 5px !important;
}

.status0 {
  color: #FF6600;
}

.status1 {
  color: #4F73FD;
}

.status2 {
  color: #00D236;
}

.status3 {
  color: #BFBFBF;
}

.status4 {
  color: #BFBFBF;
}

.yy-time b.pre-gary3 {
  color: #999999;
}

.yy-time b.pre-gary4 {
  color: #999999;
}

.yy-bottom {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 49px;
  margin-top: 9px;
  border-top: 1px solid #dedede;
  padding: 0 10px;

}

.yy-bottom button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  width: 85px;
  height: 29px;
  border-radius: 3px;
  margin-left: 10px;
}

.yy-bottom button.edit {
  background: #FFFFFF;
  border: 1px solid #2C68E4;
  color: #2C68E4;
}

.yy-bottom button.qx {
  background: #FFFFFF;
  background: #2C68E4;
  border: 1px solid #2C68E4;
  color: #ffffff;
}

.yy-bottom button.pay {
  background: #FF6600;
  border: 1px solid #FF6600;
  color: #ffffff;
}
</style>
